/**
 * reconcile-api — thin client for /api/me/reconcile/:date.
 *
 * The V2 widget reads both source='auto' and source='self' for a given day
 * and writes the self row in a single PUT. Lock state is surfaced so the UI
 * can collapse to a read-only view after submission.
 */

import { api } from "@/lib/session";

export interface ReconcileMetrics {
  outreach: number;
  live_conversations: number;
  voicemails_left: number;
  no_message_hangups: number;
  emails_sent: number;
  linkedin_dms: number;
  first_meetings: number;
  qualified_meetings: number;
  qualified_handoffs: number;
  closed_won_count: number;
  closed_won_amount: number;
  email_replies_received: number;
  no_shows: number;
}

export const ZERO_METRICS: ReconcileMetrics = {
  outreach: 0,
  live_conversations: 0,
  voicemails_left: 0,
  no_message_hangups: 0,
  emails_sent: 0,
  linkedin_dms: 0,
  first_meetings: 0,
  qualified_meetings: 0,
  qualified_handoffs: 0,
  closed_won_count: 0,
  closed_won_amount: 0,
  email_replies_received: 0,
  no_shows: 0,
};

export interface ReconcileGetResponse {
  date: string;
  auto: ReconcileMetrics;
  self: ReconcileMetrics;
  locked: boolean;
  locked_at: string | null;
  notes: string;
  offline_note: string;
}

export interface ReconcilePutBody extends Partial<ReconcileMetrics> {
  notes?: string | null;
  offline_note?: string | null;
}

export interface ReconcilePutResponse {
  ok: true;
  locked: boolean;
  locked_at: string;
}

export async function getReconcile(date: string): Promise<ReconcileGetResponse> {
  return api<ReconcileGetResponse>(`/api/me/reconcile/${date}`);
}

export async function putReconcile(
  date: string,
  body: ReconcilePutBody,
): Promise<ReconcilePutResponse> {
  return api<ReconcilePutResponse>(`/api/me/reconcile/${date}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
